module.exports = __webpack_public_path__ + "img/juan-nino-profile.7df2d347.jpg";